export default __webpack_public_path__ + "static/media/CNo.45-4.c95c8cea.jpg";